import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// Import translations directly to ensure they're available
import enTranslation from "./locales/en.json";
import ptPTTranslation from "./locales/pt-PT.json";

// Set up i18next instance
const setupI18n = () => {
  // Check if i18n is already initialized to prevent duplicate initialization
  if (i18n.isInitialized) {
    return i18n;
  }

  i18n
    // Load translations from backend
    .use(Backend)
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Initialize i18next with async option
    .init({
      // Default resources to use if backend fails
      resources: {
        en: enTranslation,
        "pt-PT": ptPTTranslation,
      },
      fallbackLng: "en",
      // Fallback key behavior - return key if translation is missing
      returnNull: false,
      returnEmptyString: false,
      defaultNS: "translation",
      debug: process.env.NODE_ENV === "development",
      interpolation: {
        escapeValue: false, // React already escapes by default
      },
      detection: {
        // Order and from where user language should be detected
        order: [
          "querystring",
          "cookie",
          "localStorage",
          "navigator",
          "htmlTag",
        ],
        // Keys or params to lookup language from
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        // Cache language in localStorage
        caches: ["localStorage", "cookie"],
      },
      // Don't wait for i18n to initialize before rendering
      react: {
        useSuspense: false,
      },
    })
    .catch((error) => {
      console.error("i18n initialization error:", error);
    });

  return i18n;
};

// Initialize and export the i18n instance
export default setupI18n();
